'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');
var Environments = require('../lib/environments');

module.exports = assign({}, ServiceClientBase.prototype, {

    /**
     * @param params
     * @param {string} params.lang language (en, fr, etc..)
     * @param {string} params.cntry country
     * @param {number} params.radius radius in miles
     * @param {string} params.address zip or city, state
     * @returns {Bluebird Promise}
     */
    getNearby: function getNearby(params, extraHeaders) {

        if (!params.radius) {
            params.radius = 20;
        }

        //todo: should we just put lat / long on object?
        if (params.location) {
            params.lat = params.location.lat;
            params.long = params.location.long;
            delete params.location;
        }

        //NOTE: added this to see 2 stores for nick in test, this MAY need to go away sometime or only be for DEV
        if (Environments.get() === Environments.environments.PQA) {
            params.hasIntBetaMO = true;
        } else if (Environments.get() !== Environments.environments.PROD) {
            params.includePOS = true;
        }

        return this.getApiRequest(this.getUrl().locationsNearby, params, extraHeaders);
    },

    /**
     * @param params
     * @param {string} params.lang language (en, fr, etc..)
     * @param {string} params.cntry country
     * @param {string} params.lat latitude
     * @param {string} params.lng longitude
     * @returns {Bluebird Promise}
     */
    getGeolocation: function getGeolocation(params, extraHeaders) {

        return this.getApiRequest(this.getUrl().geolocation, params, extraHeaders);
    },

    /**
     *
     * @param params parameters for the service call
     * @param params.siteNum site / store number
     * @returns {*}
     */
    getBySiteNum: function getBySiteNum(params, extraHeaders) {
        if (!params.siteNum) throw Error('Must supply siteNum');

        return this.getApiRequest(this.getUrl().locationsNearby, params, extraHeaders).then(function (data) {
            //hand back the location which comes in an array    
            return data.data[0];
        });
    },

    notifyWhenMobileOrderingIsAvailable: function notifyWhenMobileOrderingIsAvailable(params) {

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().mobileOrderAvailable, qs, params);
    },
    getDeliveryAvailability: function getDeliveryAvailability(queryStrings) {
        return this.getApiRequest(this.getUrl().deliveryAvailability, queryStrings);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/locationServiceClient.js
// module id = 749
// module chunks = 0